/**
 * ContaPlanoPage — domínio "Conta & plano" (`/admin/conta`), Admin Hub T11.
 * Última das 5 páginas de domínio (T7-T11).
 *
 * Três seções, nesta ordem (catálogo):
 *   - `#plano` (`DomainSection soon`, sem filho) — o DOMICÍLIO ÚNICO de
 *     "Plano e billing": antes de T1-T6 este conceito era prometido em 2
 *     lugares do nav (spec §1-3); agora só existe aqui. `ContaPlanoPage.spec.tsx`
 *     carrega o teste que torna essa promessa testável (`searchCatalog('billing')`
 *     devolve SÓ este item).
 *   - `#capabilities` (`DomainSection soon`, sem filho) — leitura do que o
 *     pacote habilita; sem backend ainda (honest-defer).
 *   - `#lifecycle` (`LifecycleSection`, extraído de `pages/TenantLifecyclePage.tsx`)
 *     — dashboard read-only de ciclo de vida + wizard de churn (ação de
 *     risco, botões próprios, fora da `StickySaveBar`).
 *
 * Não há `canManage` a resolver aqui: nenhuma das 3 seções escreve por um
 * formulário desta página (`#plano`/`#capabilities` são honest-defer;
 * `#lifecycle` é read-only + AÇÕES próprias governadas por
 * `tenant-lifecycle-transition`/`tenant-lifecycle-churning-initiate`,
 * resolvidas dentro de `LifecycleSection`/`ChurningInitiationWizard`) — e por
 * isso esta é a ÚNICA das 5 páginas de domínio sem `DomainSaveProvider`/
 * `StickySaveBar`: não há seção nenhuma para registrar.
 *
 * O gate de LEITURA de `#lifecycle` é feito UMA vez, pelo `DomainSection`
 * via catálogo (`lifecycle` → `tenant-lifecycle-read`) — `LifecycleSection`
 * não repete esse gate (ao contrário da rota antiga `pages/
 * TenantLifecyclePage.tsx`, que mantém o próprio double-gate D-B intocado,
 * fora do escopo desta task). Um decisor de leitura no caminho de domínio.
 *
 * Fidelidade — prancha "08 Dominio Conta e plano.dc.html", variante 2a. As
 * seções `#plano`/`#capabilities` da prancha desenham conteúdo rico (kv grid
 * com "Plano: Team · 12 de 15 assentos…", lista de capabilities com
 * bolinhas) — mas a própria prancha rotula esses números como "exemplo" (seu
 * texto: "número de exemplo — a tela real lê o registry"). Sem fonte viva
 * para esses dados (nem endpoint, nem hook), fabricá-los violaria "o hub não
 * mente" (P17) — por isso as duas seções permanecem honest-defer via
 * `DomainSection soon` puro, como o próprio dispatch da T11 instrui. A
 * seção `#lifecycle` da prancha desenha um resumo condensado (1 status +
 * 3 linhas de timeline + link "Abrir gestão"); aqui é o dashboard COMPLETO
 * (`LifecycleSection`) — mesma divergência já declarada pela T7 para
 * `BrandingSection` (reuso do componente real em vez de um resumo
 * fabricado). A busca "Buscar nesta página…" do cabeçalho da prancha não
 * existe — layout de `DomainPage` (T4), fora do escopo desta task (mesma
 * nota que T7-T10 já registraram).
 */
import { LifecycleSection } from '../../tenant-lifecycle/LifecycleSection';
import { CONFIG_CATALOG } from '../catalog';
import { DomainPage } from '../DomainPage';
import { DomainSection } from '../DomainSection';

function item(id: string) {
  const found = CONFIG_CATALOG.find((i) => i.id === id);
  if (found === undefined) throw new Error(`Item de catálogo ausente: ${id}`);
  return found;
}

export function ContaPlanoPage(): JSX.Element {
  return (
    <DomainPage dominio="conta">
      <DomainSection item={item('plano')}>{null}</DomainSection>
      <DomainSection item={item('capabilities')}>{null}</DomainSection>
      <DomainSection item={item('lifecycle')}>
        <LifecycleSection />
      </DomainSection>
    </DomainPage>
  );
}
